import React, { Component } from "react";
import { List, Button, Icon, Card, Table, Grid, Form } from "tabler-react";
import { Crud_Catalogos, Crud_error } from '../../../../herramientas/Crud_Catalogos';

import axios from 'axios';

class EtaCalculadaTerrestre extends Component {
    constructor(props) {
        super(props);
        //console.log(this.props);
        this.state = {
            etaCalculadas: [],
            etaCalculadasT: [],
        };
    }

    componentDidMount = () => {
        this.getEtaTerrestre();

    }

    getEtaTerrestre = () => {
        Crud_Catalogos("terrestreEtasCalculadas/entrega/"+this.props.idEntrega, "terrestreEtaCalculadas", "get", "", [], "", this.state.etaCalculadasT, "", []).then((returnVal) => {
            this.etaCalculadasT = returnVal;
            this.setState({ etaCalculadasT: returnVal });
            //console.log(this.state.etaCalculadasT);

        }).catch(err => {
            if (err.response) {
                console.log(err);
            } else {
                /**
                 * Error
                 */
            }
        })
    }

    render() {
        return (

            <div className="table-responsive">
                <Table className="table table-striped">
                    <Table.Header>
                        <Table.ColHeader>ID</Table.ColHeader>
                        <Table.ColHeader>Entrega</Table.ColHeader>
                        <Table.ColHeader>Origen Latitud</Table.ColHeader>
                        <Table.ColHeader>Origen Longitud</Table.ColHeader>
                        <Table.ColHeader>Origen Direccion</Table.ColHeader>
                        <Table.ColHeader>Destino Latitud</Table.ColHeader>
                        <Table.ColHeader>Destino Longitud</Table.ColHeader>
                        <Table.ColHeader>Destino Direccion</Table.ColHeader>
                        <Table.ColHeader>Fecha Calculo</Table.ColHeader>
                        <Table.ColHeader>Distancia</Table.ColHeader>
                        <Table.ColHeader>Tiempo</Table.ColHeader>
                        <Table.ColHeader>Eta</Table.ColHeader>
                        <Table.ColHeader>Cita Programada (Cita Carga)</Table.ColHeader>
                        <Table.ColHeader>Tipo Calculo</Table.ColHeader>
                        <Table.ColHeader>Tipo Entrega</Table.ColHeader>
                        <Table.ColHeader>Estatus</Table.ColHeader>
                        <Table.ColHeader>ONTIME</Table.ColHeader>
                
                    </Table.Header>
                    {   
                        this.state.etaCalculadasT.map(etasCalculadas =>
                            <Table.Body>
                                <Table.Row>                                    
                                    <Table.Col>{etasCalculadas.idEtaCalculada}</Table.Col>
                                    <Table.Col>{etasCalculadas.idEntrega}</Table.Col>
                                    <Table.Col>{etasCalculadas.origenLatitud}</Table.Col>
                                    <Table.Col>{etasCalculadas.origenLongitud}</Table.Col>
                                    <Table.Col>{etasCalculadas.origenDireccion}</Table.Col>
                                    <Table.Col>{etasCalculadas.destinoLatitud}</Table.Col>
                                    <Table.Col>{etasCalculadas.destinoLongitud}</Table.Col>
                                    <Table.Col>{etasCalculadas.destinoDireccion}</Table.Col>
                                    <Table.Col>{etasCalculadas.fechaCalculo}</Table.Col>
                                    <Table.Col>{etasCalculadas.distancia}</Table.Col>
                                    <Table.Col>{etasCalculadas.tiempo}</Table.Col>
                                    <Table.Col>{etasCalculadas.eta}</Table.Col>
                                    <Table.Col>{this.props.elementos.citaCarga}</Table.Col>
                                    <Table.Col>{etasCalculadas.tiempoCalculo}</Table.Col>
                                    <Table.Col>{etasCalculadas.tipoEntrega}</Table.Col>      
                                    <Table.Col>{etasCalculadas.estatus}</Table.Col>
                                    <Table.Col>
                                        <span style={{                                            
                                            color: new Date(etasCalculadas.eta) <= new Date(this.props.elementos.citaCarga) ? 'green' : 'red',
                                            fontWeight: 'bold'
                                        }}>
                                            {new Date(etasCalculadas.eta) <= new Date(this.props.elementos.citaCarga) ? 'En tiempo' : 'Tarde'}
                                        </span>
                                    </Table.Col>
                                </Table.Row>
                            </Table.Body>
                        )
                    }
                </Table>

            </div>
        );
    }
}
export default EtaCalculadaTerrestre;